import React from 'react';
import axios from 'axios';
import {FilterActionTypes, StateMapper} from "easy-peasy";
import parse from 'html-react-parser';
import { API, buildDataServerAuthorizationHeaders } from '../../constants/ApiRoutes';
import { useStoreState } from '../../store/hooks';
import {AppStoreModel} from "../../store/model";
import { StAccessibility } from './Accessibility.style';

const Accessibility: React.FunctionComponent = () => {
  const currentTranslation = useStoreState((state: StateMapper<FilterActionTypes<AppStoreModel>>) => state.intl.locale);
  const [accessibilityComponent, setAccessibilityComponent] = React.useState<any>();

  React.useEffect(() => {
    async function getAccessibility() {
      await axios(
        `${API.INTRANET.GET_ACCESSIBILITY}?lang=${currentTranslation}`,
        {
          headers: buildDataServerAuthorizationHeaders(),
        },
      )
        .then(response => {
          setAccessibilityComponent(parse(response.data.result.accessibility));
        })
        .catch(error => {
          alert(`get accessibility ERROR : ${error}`);
        });
    }

    getAccessibility().then();

  }, [currentTranslation]);

  return (
    <StAccessibility className="d-flex justify-content-center py-4 px-5">
      <div className="container-sm">
      {accessibilityComponent}
      </div>
    </StAccessibility>
  );
};

export default Accessibility;
